import { Loader2 } from "lucide-react"

const PageLoader = () => (
  <div className="flex flex-1 items-center justify-center animate-fade-in-delayed">
    <Loader2 className="h-6 w-6 animate-spin text-gray-400" />
  </div>
)

export default PageLoader
